/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { bool, func } from 'prop-types';
import { Link, makeStyles } from '@material-ui/core';
import ReactDOM from 'react-dom';

function SlideUp(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Slide {...props} direction="up" />;
}
const useStyles = makeStyles((theme) => ({
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        '@media only screen and (max-width: 450px) ': {
            gap: '5px',
        },
    },
    viewButton: {
        textDecoration: 'underline',
        fontWeight: 700,
        marginLeft: '12px',
        fontSize: '16px',
        '@media only screen and (max-width: 450px) ': {
            fontSize: '13px',
            marginLeft: '4px',

        },
    },
    addToFavorite: {
        fontSize: '16px',
        '@media only screen and (max-width: 450px) ': {
            fontSize: '13px',
        },
    },
    closeIcon: {
        '@media only screen and (max-width: 450px) ': {
            width: '23px',
            height: '23px',
        },
    },
}));
const FavoriteSnackbar = ({ open, onClose }) => {
    const classes = useStyles();
    return (
        ReactDOM.createPortal(<Snackbar
            open={open}
            onClose={onClose}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            TransitionComponent={SlideUp}
            message={(
                <div className={classes.mainContainer}>
                    <svg width="21" height="18" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2243 0.636223C19.2576 0.216191 20.3651 0 21.4835 0C22.6019 0 23.7094 0.216191 24.7426 0.636223C25.7757 1.05618 26.7143 1.67167 27.5049 2.44755C28.2957 3.22318 28.9235 4.14447 29.3515 5.15799C29.7796 6.1717 30 7.25823 30 8.35552C30 9.45281 29.7796 10.5393 29.3515 11.553C28.9234 12.5667 28.296 13.4876 27.5051 14.2633L15.9259 25.6236C15.4143 26.1255 14.585 26.1255 14.0734 25.6236L2.49422 14.2633C0.897199 12.6964 0 10.5714 0 8.35552C0 6.13968 0.897199 4.0146 2.49422 2.44776C4.09125 0.880926 6.25728 0.000687239 8.51582 0.000687239C10.7744 0.000687239 12.9404 0.880926 14.5374 2.44776L14.9997 2.90127L15.4617 2.44798C16.2523 1.672 17.1912 1.05622 18.2243 0.636223ZM21.4835 2.57021C20.7092 2.57021 19.9425 2.71988 19.2272 3.01067C18.5118 3.30146 17.8619 3.72767 17.3145 4.26496L15.9259 5.62738C15.4143 6.12925 14.585 6.12925 14.0734 5.62738L12.685 4.26517C11.5792 3.18035 10.0796 2.5709 8.51582 2.5709C6.95208 2.5709 5.45238 3.18035 4.34665 4.26517C3.24092 5.35 2.61973 6.82134 2.61973 8.35552C2.61973 9.8897 3.24092 11.361 4.34665 12.4459L14.9997 22.8975L25.6526 12.4459C26.2003 11.9088 26.6349 11.271 26.9313 10.5692C27.2277 9.8674 27.3803 9.11518 27.3803 8.35552C27.3803 7.59586 27.2277 6.84365 26.9313 6.14185C26.6349 5.44005 26.2005 4.80242 25.6529 4.26539C25.1055 3.7281 24.4551 3.30146 23.7398 3.01067C23.0245 2.71988 22.2578 2.57021 21.4835 2.57021Z" fill="#185357" />
                        <path d="M19.2272 3.01067C19.9425 2.71988 20.7092 2.57021 21.4835 2.57021C22.2578 2.57021 23.0245 2.71988 23.7398 3.01067C24.4551 3.30146 25.1055 3.7281 25.6529 4.26539C26.2005 4.80242 26.6349 5.44005 26.9313 6.14185C27.2277 6.84365 27.3803 7.59586 27.3803 8.35552C27.3803 9.11518 27.2277 9.8674 26.9313 10.5692C26.6349 11.271 26.2003 11.9088 25.6526 12.4459L14.9997 22.8975L4.34665 12.4459C3.24092 11.361 2.61973 9.8897 2.61973 8.35552C2.61973 6.82134 3.24092 5.35 4.34665 4.26517C5.45238 3.18035 6.95208 2.5709 8.51582 2.5709C10.0796 2.5709 11.5792 3.18035 12.685 4.26517L14.0734 5.62738C14.585 6.12925 15.4143 6.12925 15.9259 5.62738L17.3145 4.26496C17.8619 3.72767 18.5118 3.30146 19.2272 3.01067Z" fill="#BDDFCE" />
                    </svg>
                    <span className={classes.addToFavorite}>Added to your favorites</span>
                    <Link href="/account/favorite" className={classes.viewButton}>
                        View
                    </Link>
                </div>
            )}
            ContentProps={{
                style: {
                    backgroundColor: '#F3F1FC',
                    color: '#000',
                    fontWeight: 600,
                    borderRadius: '5px',
                    paddingRight: '12px',
                    zIndex: 9999,
                    border: '1px solid #848484',
                    fontSize: '20px',
                    width: 'max-content',
                    maxWidth: '440px',
                },
            }}
            action={(
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={onClose}
                >
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            )}
        />,
        document.body,
        ));
};
FavoriteSnackbar.propTypes = {
    open: bool.isRequired,
    onClose: func.isRequired,
};

export default FavoriteSnackbar;
